import React from 'react'
import NextStepButton from './NextStepButton'
import {usePurchaseForm} from './PurchaseFormProvider'
import PurchaseButton from './PurchaseButton'
import {usePurchase} from '../../PurchaseContext'
import {BlockComponentProps} from '../index'
import {PurchaseFormBlock} from '../PurchaseForm'
import {useSection} from '../../Section'
import Visible from '../../lib/ui/Visible'
import styles from './PurchaseForm.module.css'

interface CustomerDetailStepProps
  extends PurchaseFormBlock,
    BlockComponentProps {
  disabled?: boolean
  onContinue: () => void
  TextFieldComponent: React.FC<any>
  ButtonComponent: React.FC<any>
}

export default function CustomerDetailStep(props: CustomerDetailStepProps) {
  const {
    onContinue,
    disabled,
    TextFieldComponent,
    ButtonComponent,
    ...config
  } = props

  const {calculateVisibility} = useSection()
  const {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    email,
    setEmail,
    phoneNumber,
    setPhoneNumber,
  } = usePurchaseForm()

  const handleContinue = async () => {
    const valid = true

    if (valid) {
      onContinue()
    } else {
      calculateVisibility()
    }
  }

  return (
    <div>
      <div>
        <TextFieldComponent
          aria-label="purchase first name"
          config={config}
          placeholder="firstName"
          inputProps={{
            'aria-label': 'first name',
          }}
          value={firstName}
          onChange={(e: any) => setFirstName(e)}
        />
      </div>
      <div>
        <TextFieldComponent
          aria-label="purchase last name"
          config={config}
          disabled={disabled}
          placeholder="lastName"
          inputProps={{
            'aria-label': 'last name',
          }}
          value={lastName}
          onChange={(e: any) => setLastName(e)}
        />
      </div>
      <div>
        <TextFieldComponent
          aria-label="purchase email"
          config={config}
          disabled={disabled}
          placeholder="email"
          inputProps={{
            'aria-label': 'email',
          }}
          value={email}
          onChange={(e: any) => setEmail(e)}
        />
      </div>
      <Visible when={config.phoneNumber.enabled}>
        <div>
          <TextFieldComponent
            aria-label="purchase phone number"
            config={config}
            disabled={disabled}
            placeholder="phone"
            inputProps={{
              'aria-label': 'phone number',
            }}
            value={phoneNumber}
            onChange={(e: any) => setPhoneNumber(e)}
          />
        </div>
      </Visible>
      <div className={styles.formButtonBox}>
        <ConfirmButton
          ButtonComponent={ButtonComponent}
          config={config}
          disabled={disabled}
          onNextStep={handleContinue}
        />
      </div>
    </div>
  )
}

function ConfirmButton(props: {
  ButtonComponent: React.FC<any>
  config: PurchaseFormBlock & BlockComponentProps
  disabled?: boolean
  onNextStep: () => void
}) {
  const {selectedTicket} = usePurchase()
  const {ButtonComponent, config, disabled, onNextStep: handleContinue} = props
  if (selectedTicket?.price === 0) {
    return <PurchaseButton ButtonComponent={ButtonComponent} {...config} />
  }

  return (
    <NextStepButton
      ButtonComponent={ButtonComponent}
      {...config}
      disabled={disabled}
      onClick={handleContinue}
    />
  )
}
